module.exports = __webpack_public_path__ + "static/media/pic10.21d2e502.jpg";